import React from 'react';
import { View, Text, StyleSheet, } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
// import { BackgroundGradient, Loader, } from '../../components';

const ProjectHistory = ({ history }) => {
  const [entries, setEntries] = React.useState([]);

  React.useEffect(() => {
    let e = [];
    // console.log('ProjectHistory: ', history);
    Object.keys(history).map(h => {
      history[h].map((entry, i) => {
        e.push(entry);
        // console.log(`${i}::${entry.date} ${entry.memo}`);
      })
    })
    setEntries(e);
  }, [history]);
  return (
    <View style={styles.container}>
      <Text style={[CS.smallTitle, CS.lightText, { marginTop: 0, marginBottom: 10 }]}>Change Orders</Text>
      {/* {Object.keys(history).map(h => {
        history[h].map((entry, i) => {
          return (
            <View style={styles.historyEntry} key={i}>
              <Text style={[CS.smallText, CS.lightBlueText]}>{entry.date}</Text>
              <Text style={[CS.smallText, CS.lightText]}>{entry.memo}</Text>
            </View>
          )
        });
      })} */}
      {entries.map((entry, i) => {
        return (
          <View key={i}>
            <View style={styles.historyEntry}>
              <Text style={[CS.smallText, CS.lightBlueText]}>{entry.date}</Text>
              <Text style={[CS.smallText, CS.lightText, { marginTop: 5 }]}>{entry.memo}</Text>
            </View>
            {(i !== entries.length - 1) &&
              <View style={styles.separator}></View>
            }
          </View>
        )
      })}
    </View>
  );

}

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
  },
  historyEntry: {
    // marginBottom: 10,
  },
  separator: {
    borderTopWidth: 1,
    borderColor: Colors.lightBlue,
    marginVertical: 15,
  }
});

export default ProjectHistory;